import React, { useEffect } from "react";
import {
  Stack,
  Button,
  FormControlLabel,
  Checkbox,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

export default function DateFilterBar({
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  onApply,
  fullMonth,
  setFullMonth,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (!fromDate && !toDate) {
      const today = dayjs();

      if (fullMonth) {
        setFromDate(today.startOf("month"));
        setToDate(today.endOf("month"));
      } else {
        setFromDate(today.startOf("day"));
        setToDate(today.endOf("day"));
      }
    }
  }, [fromDate, toDate, fullMonth, setFromDate, setToDate]);

 const handleFromChange = (value) => {
    if (!value) {
      setFromDate(value);
      return;
    }

    if (fullMonth) {
      // setFromDate(dayjs(value).startOf("month"));
      // setToDate(dayjs(value).endOf("month"));
      setFullMonth(false);
      setFromDate(value);
      return;
    }

    setFromDate(value);

    // if the new From date is after the current To date, push To
    // forward to match — a range can never end before it starts
    if (toDate && dayjs(value).isAfter(dayjs(toDate), "day")) {
      setToDate(value);
    }
  };

  const handleToChange = (value) => {
    if (!value) {
      setToDate(value);
      return;
    }

    if (fullMonth) {
      // setFromDate(dayjs(value).startOf("month"));
      // setToDate(dayjs(value).endOf("month"));
      setFullMonth(false);
      setToDate(value);
      return;
    }

    // if the new To date is before the current From date, pull From
    // backward to match — same logic, mirrored
    if (fromDate && dayjs(value).isBefore(dayjs(fromDate), "day")) {
      setFromDate(value);
    }

    setToDate(value);
  };

  const handleFullMonthChange = (event) => {
    const checked = event.target.checked;
    setFullMonth(checked);

    if (checked) {
      const baseDate = fromDate || toDate || dayjs();
      setFromDate(dayjs(baseDate).startOf("month"));
      setToDate(dayjs(baseDate).endOf("month"));
    }
  };

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      alignItems={{ xs: "stretch", sm: "center" }}
      flexWrap="wrap"
      sx={{ width: "100%" }}
    >
     <DatePicker
      label="From"
      value={fromDate}
      onChange={handleFromChange}
      maxDate={toDate || undefined}
      slotProps={{ textField: { fullWidth: isMobile, size: "small" } }}
    />

    <DatePicker
      label="To"
      value={toDate}
      onChange={handleToChange}
      minDate={fromDate || undefined}
      slotProps={{ textField: { fullWidth: isMobile, size: "small" } }}
    />

      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        justifyContent={{ xs: "space-between", sm: "flex-start" }}
        sx={{ width: { xs: "100%", sm: "auto" } }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={!!fullMonth}
              onChange={handleFullMonthChange}
            />
          }
          label="Full month"
        />

        {/* <Button
          variant="contained"
          onClick={() => onApply(fromDate, toDate)}
          sx={isMobile ? { flexShrink: 0 } : {}}
        >
          Apply
        </Button> */}
      </Stack>
    </Stack>
  );
}